import React from 'react';

import { ReactComponent as ArrowRightIcon } from '@pkg/assets/icons/v2/arrow-right.svg';
import { IconWrapper, StyledLink } from '@pkg/components/Sections/Admin';
import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { type Prize, type TeamWinner, type Winner } from '@app/client/common/structs';
import { type GameItemData } from '@app/pages/FantasyWishlist/sections/LeaderboardSection/types';

import { Typography } from '../../../../../DesignSystem';

import { Content, WinnerIdWrapper, Wrapper } from './styles';

export type WinnerWithLBData = Winner & Partial<GameItemData>;
export type TeamWinnerWithLBData = TeamWinner & Partial<GameItemData>;
interface WinnerItemProps {
    winner?: WinnerWithLBData;
    teamWinner?: TeamWinnerWithLBData;
    onAssignNewWinner: () => void;
}

function WinnerDetails({ winnerDisplayName, prize }: { winnerDisplayName?: string; prize?: Prize }) {
    return (
        <Content>
            <div>
                <span>
                    <strong>#{prize?.rank}</strong> {prize?.name}
                </span>
                <br />
                <strong>{prize?.reward}</strong>
            </div>
            <WinnerIdWrapper>
                Winner: <strong>{winnerDisplayName}</strong>
            </WinnerIdWrapper>
        </Content>
    );
}
export const WinnerItem = ({ winner, teamWinner, onAssignNewWinner }: WinnerItemProps) => {
    const winnerDisplayName = `${winner?.yat} - ${winner?.username || winner?.user_id}`;
    return (
        <>
            <Wrapper>
                {winner ? <WinnerDetails winnerDisplayName={winnerDisplayName} prize={winner?.prize} /> : null}
                {teamWinner ? (
                    <WinnerDetails winnerDisplayName={teamWinner.team_name} prize={teamWinner?.prize} />
                ) : null}
                <Content $alignRight>
                    <Button color="transparent" onClick={onAssignNewWinner} size="xsmall">
                        Assign a new winner
                    </Button>
                    {winner && (
                        <StyledLink to={`/admin/users/${winner?.user_id}`} target="_blank">
                            <Typography type="label" size={14}>
                                Go to winner user page
                            </Typography>
                            <IconWrapper>
                                <ArrowRightIcon />
                            </IconWrapper>
                        </StyledLink>
                    )}
                </Content>
            </Wrapper>
        </>
    );
};
